/**
 * 处理视频通话中的礼物赠送消息 SEND_GIFT
 *
 * 职责：
 * 1. 接收 IM 推送的 SEND_GIFT 消息
 * 2. 验证消息是否属于当前视频通话会话
 * 3. 添加到 videoCallStore 的消息列表中
 * 4. 支持礼物特效展示（如需要）
 */

import { useVideoCallStore } from '@/stores/videoCall'
import { useUserStore } from '@/stores/user'
import { VIDEO_MSG_TYPES } from '@/common/constants/videoMsgTypes'

/**
 * @param {Object} event - EventBus 事件对象
 * @param {Object[]} event.data - IMManager 派发的消息数组
 */
export function handleVideoCallGiftMessages(event) {
  console.log('[handleVideoCallGiftMessages] event:', event)
  const { data: messages } = event
  if (!Array.isArray(messages) || messages.length === 0) return
  const videoCallStore = useVideoCallStore()
  const currentRoomInfo = videoCallStore.currentRoomInfo
  // 只处理当前视频通话会话的礼物消息
  // 通过比对发送方或接收方的 member_id 来判断
  if (!currentRoomInfo) {
    return
  }

  const userStore = useUserStore()
  const currentMemberId = userStore.getMemberId()

  // 添加到 videoCallStore 的消息列表
  videoCallStore.addMessages(
    messages
      .filter(({ msg_content }) => {
        const {
          member,
          target,
        } = msg_content

        const isSender = member.member_id === currentMemberId
        const isReceiver = target.member_id === currentMemberId
        const otherMemberId = isSender ? target.member_id : member.member_id
        // 检查双方是否在当前会话当中
        return (isSender || isReceiver) && !!currentRoomInfo.live_members?.[otherMemberId]
      })
      .map(({ msg_content, timestamp, client_id }, index) => ({
        ...msg_content,
        id: `${client_id}-${timestamp}-${index}`,
        type: VIDEO_MSG_TYPES.SEND_GIFT,
      }))
  )
}
